import {
  BoxProps,
  Grid,
  GridItem,
  HStack,
  IconButton,
  Text,
} from "@chakra-ui/react";
import { Dispatch, SetStateAction } from "react";
import { AiFillEdit } from "react-icons/ai";
import { formatTextDisplay } from "../../utils/displayGetters";
import { CopyButton } from "../copyButton/CopyButton";

export const DetailField = ({
  label,
  value,
  format = false,
  openModal,
  setModalOption,
  isCopyField = false,
  isComma = true,
  variant,
  ...rest
}: {
  label: string;
  value?: any;
  format?: boolean;
  openModal?: () => void;
  setModalOption?: Dispatch<SetStateAction<string>>;
  isCopyField?: boolean;
  isComma?: boolean;
  variant?: string;
} & BoxProps) => {
  const variants = variant === "flex"
  return (
    <Grid
      templateColumns={variants? "flex" : "repeat(8, 1fr)"}
      gap={variants? "2" : "6"}
      mb={4}
      alignItems={"start"}
      {...rest}
    >
      <GridItem colSpan={3}>
        <Text
          mr={1}
          color={"primary.darker"}
          fontWeight={variants? "semibold" : "bold"}
          fontSize={"sm"}
        >
          {label}
        </Text>
      </GridItem>
      <GridItem colSpan={5}>
        {value && value.constructor === Array ? (
          value.map((v, ix) => {
            if (isCopyField) {
              return (
                <HStack spacing={"5"} mb={4}>
                  <CopyField
                    value={v}
                    format={format}
                  />
                </HStack>
              )
            } else {
              return (
                <Text key={v + ix} mr={1}>
                  {format ? formatTextDisplay(v) : v}
                  <span
                    style={{
                      visibility: ix !== value.length - 1 ? "visible" : "hidden",
                    }}
                  >
                    {isComma ? `,` : ``}
                  </span>
                </Text>
              )
            }
          })
        ) : (
          <HStack spacing={"5"}>
            {isCopyField ? (
              <CopyField
                value={value}
                format={format}
              />
            ) : (
              <Text wordBreak={"break-all"}>
                {format ? formatTextDisplay(value) : value}
              </Text>
            )}
            {openModal && setModalOption && (
              <IconButton
                aria-label={"Edit"}
                m={0}
                variant={"unStyled"}
                icon={<AiFillEdit />}
                color={"primary.darker"}
                size={"sm"}
                onClick={() => {
                  setModalOption(label);
                  openModal();
                }}
              />
            )}
          </HStack>
        )}
      </GridItem>
    </Grid>
  );
};

interface CopyFieldProps {
  value: any;
  format: boolean;
  title?: string;
}

const CopyField = ({value, format, title="ID"}: CopyFieldProps) => {

  return (
    <HStack
      spacing={0}
      bg={"white"}
      borderRadius={"3px"}
      borderColor = {"greyInput"}
      borderWidth={"1px"}
    >
      <Text
        // fontFamily={"mono"}
        marginLeft={2}
        p={1}
        fontSize={["sm"]}
        wordBreak={"break-all"}
      >
        {format ? formatTextDisplay(value) : value}
      </Text>
      <CopyButton textCopied={value} title={title} />
    </HStack>
  )
}
